(() => {
  if (window.CiranovaGuidedPurchase) {
    window.CiranovaGuidedPurchase.init(document);
    return;
  }

  const ROOT_SELECTOR = '[data-cn-guide]';
  const MAIN_SELECTOR = '[id$="__main-product"]';

  const getMainProduct = () => document.querySelector(MAIN_SELECTOR);

  const selectedValues = (main) => {
    const values = [];

    main.querySelectorAll('select[name^="options"]').forEach((select) => {
      if (select.value) values.push(select.value);
    });

    main.querySelectorAll('input[data-option-value]:checked').forEach((input) => {
      if (input.dataset.optionValue) values.push(input.dataset.optionValue);
    });

    return values;
  };

  const chooseValue = (value) => {
    const main = getMainProduct();
    if (!main) return false;

    const optionInput = [...main.querySelectorAll('input[data-option-value]')]
      .find((input) => input.dataset.optionValue === value);

    if (optionInput) {
      if (optionInput.disabled) return false;
      optionInput.click();
      return true;
    }

    const optionSelect = [...main.querySelectorAll('select[name^="options"]')]
      .find((select) => [...select.options].some((option) => option.value === value));

    if (optionSelect) {
      const option = [...optionSelect.options].find((item) => item.value === value);
      if (!option || option.disabled) return false;
      optionSelect.value = value;
      optionSelect.dispatchEvent(new Event('input', { bubbles: true }));
      optionSelect.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  };

  const syncGuide = (root) => {
    const main = getMainProduct();
    if (!main) return;

    const activeValues = selectedValues(main);
    const activeLabels = [];

    root.querySelectorAll('[data-guide-value]').forEach((button) => {
      const isSelected = activeValues.includes(button.dataset.guideValue);
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', String(isSelected));
      if (isSelected && button.dataset.choiceLabel) {
        activeLabels.push(button.dataset.choiceLabel);
      }
    });

    const summary = root.querySelector('[data-guide-summary]');
    if (summary) {
      summary.textContent = activeLabels.length
        ? activeLabels.join(' / ')
        : 'Choose an option to begin.';
    }
  };

  const reveal = (root) => {
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    observer.observe(root);
  };

  const initRoot = (root) => {
    if (root.dataset.cnGuideReady === 'true') return;
    root.dataset.cnGuideReady = 'true';

    root.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-guide-value]');
      if (choice && root.contains(choice)) {
        const changed = chooseValue(choice.dataset.guideValue);
        if (!changed) {
          const summary = root.querySelector('[data-guide-summary]');
          if (summary) summary.textContent = 'This option is currently unavailable.';
        }
        window.requestAnimationFrame(() => syncGuide(root));
        return;
      }

      const review = event.target.closest('[data-guide-review]');
      if (review && root.contains(review)) {
        const main = getMainProduct();
        if (!main) return;
        main.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    });

    const main = getMainProduct();
    if (main) {
      main.addEventListener('change', () => {
        window.requestAnimationFrame(() => syncGuide(root));
      });
    }

    syncGuide(root);
    reveal(root);
  };

  const init = (scope = document) => {
    const roots = scope.matches?.(ROOT_SELECTOR)
      ? [scope]
      : [...scope.querySelectorAll(ROOT_SELECTOR)];
    roots.forEach(initRoot);
  };

  window.CiranovaGuidedPurchase = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();

